/**
 * The type of authentication used for loyalty.
 */
export var LoyaltyAuthenticationType;
(function (LoyaltyAuthenticationType) {
    /**
     * Authenticate with OCAPI using JWT access tokens.
     */
    LoyaltyAuthenticationType["Token"] = "Token";
    /**
     * Authenticate with OCAPI using cookie based sessions.
     */
    LoyaltyAuthenticationType["Cookie"] = "Cookie";
    /**
     * Authenticate with OCAPI using workstation cookie based sessions.
     */
    LoyaltyAuthenticationType["WorkstationCookie"] = "WorkstationCookie";
})(LoyaltyAuthenticationType || (LoyaltyAuthenticationType = {}));
//# sourceMappingURL=loyalty-authentication-type.js.map